import { useApiQuery } from "../../../services/api";

const MIN_QUERY_LENGTH = 3;

export interface SearchSuggestions {
  refineQueries: readonly string[];
  isLoading: boolean;
}

const EMPTY: SearchSuggestions = { refineQueries: [], isLoading: false };

export function useSearchSuggestionsQuery(
  searchValue: string
): SearchSuggestions {
  const trimmed = searchValue.trim();
  const isEnabled = trimmed.length >= MIN_QUERY_LENGTH;

  const query = useApiQuery(
    "/webapp/public/articles/search-suggestions",
    isEnabled ? { query: { q: trimmed } } : false
  );

  if (query.state === "success") {
    return { refineQueries: query.body.refineQueries, isLoading: false };
  }
  if (query.state === "pending") {
    return { refineQueries: [], isLoading: true };
  }
  return EMPTY;
}
